import axios from "axios";
import { Payout_Service } from "../Url";

export const categoryListAction = {
  SETUP_CATEGORY_LIST: "SETUP_CATEGORY_LIST",
  SETUP_CATEGORY_LIST_ERROR: "SETUP_CATEGORY_LIST_ERROR",
};

export function getCategoryList(props) {
  const {accessToken } = props;
  return async (dispatch) => {
    try {
      
      const response = await axios({
        method: "post", 
         url: `${Payout_Service}/pricing/category`,
        // url: "http://localhost:8301/partner-payout-service/pricing/category",
        headers: { 
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
         
        },
       
       
      });
      const data = response.data;
      dispatch({
        type: categoryListAction.SETUP_CATEGORY_LIST,
        payload: data.data,
      });
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: categoryListAction.SETUP_CATEGORY_LIST_ERROR,
        payload: error.message || "Failed to fetch Category data",
      });
    }
  };
}
